import React, { useRef } from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import { Tooltip } from "@material-ui/core";

function handleClick(event) {
    event.preventDefault();
}

/**
 * @Description MateDrive BreadCrumbs design
 * @Param       selectItem - selected file or / folder
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function MateDriveBreadcrumbs({ selectItem, isFileSelect, from, isFolderSelect, handleOnChange }) {
    const { t } = useTranslation();

    // copy button clicked then The path it is in is copied.
    const copyText = useRef(null);
    const setAlert = useSetRecoilState(alertState);

    const handleCopy = () => {
        try {
            copyText.current.style = "display:block;position:absolute;left:99999;"
            copyText.current.children[0].children[0].select();
            copyText.current.children[0].children[0].setSelectionRange(0, 99999);
            document.execCommand('copy');
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.AUTOM-COPIED'), severity: 'success' }));

        } catch (err) {
            console.error('Failed to copy: ', err);
        }
        copyText.current.style = "display:none !important;position:absolute;left:99999;"
        if (from) {
            handleOnChange("mate:" + (isFolderSelect && !selectItem?.path ? "/" : "") + (selectItem?.path === undefined ? "Root/" : selectItem?.path), true)
        }
    }
    return (
        <>
            <Breadcrumbs className="mate-drive-breadcrumb-container" aria-label="breadcrumb" style={{ paddingLeft: 5 }}>
                <Tooltip title={selectItem?.path.length > 55 ? "Root" + selectItem.path : ""} placement="top">
                    <Link className="mate-drive-path-name-container" color="inherit" href="/" onClick={handleClick}>
                        Root{selectItem?.path}
                    </Link>
                </Tooltip>
                <Button
                    disabled={from === "filePath" && !isFileSelect || from === "folderPath" && !isFolderSelect}
                    className="matedrive-breadcrumbs-button"
                    size="small"
                    variant="outlined"
                    onClick={() => handleCopy()}
                >
                    {from ? t(`CONTENT.MATE-DRIVE.SELECT-${from === "filePath" ? "FILE" : "FOLDER"}`) : t("CONTENT.MATE-DRIVE.COPY")}
                </Button>
            </Breadcrumbs>
            <TextField
                id="filled-size-small"
                style={{ display: 'none', position: 'absolute', left: 99999 }}
                ref={copyText}
                value={"mate:" + (selectItem?.path === undefined ? "Root/" : selectItem?.path) + (isFolderSelect ? "/" : "")}
                variant="outlined"
                size="small"
                readOnly
                fullWidth
            />
        </>
    );
}


export default MateDriveBreadcrumbs;
